module.exports = __webpack_public_path__ + "img/star-off.8316b8a1.png";